export default __webpack_public_path__ + "static/media/ezor-gps.1f85e5f3.png";